import React, { useContext, useState } from "react";
import {
  StyleSheet,
  View,
  Image,
  Pressable,
  Text,
  useWindowDimensions,
} from "react-native";
import { useNavigate } from "react-router-dom";

import global from "../../../styles/globalStyles";
import SessionContext from "../../../contexts/session";
import { supabase } from "../../../utils/supabase";

import { Close, Hamburger, Person, PersonAdd } from "../../../assets/index";
import { ModalOpener } from "./modals";
import ProfileModal from "../../common/native/ProfileModal";

type DashboardHeaderProps = {
  handleToggleHamburger: () => void;
  isMobileMenuOpen: boolean;
  hideSignout?: boolean;
};

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  handleToggleHamburger,
  isMobileMenuOpen,
  hideSignout = false,
}) => {
  const navigate = useNavigate();
  const { width, height } = useWindowDimensions();
  const isMobile = Math.min(width, height) < 644;
  const session = useContext(SessionContext)?.session;

  const [isInviteModalOpen, setIsInviteModalOpen] = useState<boolean>(false);
  const [isProfileOpen, setIsProfileOpen] = useState<boolean>(false);

  const handleLogoClick = () => {
    navigate("/home");
  };

  return (
    <View style={styles.headerContainer}>
      <View style={styles.leftContainer}>
        <Pressable
          onPress={handleLogoClick}
          accessibilityRole="link"
          aria-label="Go to home page"
        >
          <Image
            source={{
              uri: "https://clinic-os.com/user-app-assets/header-clinicos.png",
            }}
            style={styles.image}
          />
        </Pressable>
      </View>

      <View style={styles.rightContainer}>
        {!hideSignout && (
          <>
            <Pressable onPress={() => setIsInviteModalOpen(true)}>
              <PersonAdd />
            </Pressable>

            {/* Profile button -> opens ProfileModal */}
            <Pressable onPress={() => setIsProfileOpen(true)}>
              <Person />
            </Pressable>
          </>
        )}

        {isMobile ? (
          <Pressable onPress={handleToggleHamburger}>
            {isMobileMenuOpen ? <Close /> : <Hamburger />}
          </Pressable>
        ) : null}
      </View>

      {/* Invite Member Modal */}
      {!hideSignout && (
        <ModalOpener
          visible={isInviteModalOpen}
          modalType={"InviteAMember"}
          onClose={() => setIsInviteModalOpen(false)}
        />
      )}

      {/* Profile Modal (shows clinic name, email, role, and sign out) */}
      {!hideSignout && (
        <ProfileModal
          visible={isProfileOpen}
          onClose={() => setIsProfileOpen(false)}
          onSignedOut={() => navigate("/signin")}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#DDDEE0",
    backgroundColor: "#fff",
  },
  rightContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
  },
  leftContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
  },
  image: {
    width: 90,
    height: 30,
  },
});

export default DashboardHeader;
